<template>
  <dashboard-block
    title="Скорость доставки"
    :caption="caption"
    :loading="loading"
    :missing="!block"
    :min-height="232"
    skeleton="list-item-two-line@3"
  >
    <template v-if="block && block.hasFigures">
      <dashboard-bar-row
        v-for="stage in stages"
        :key="stage.label"
        :label="stage.label"
        :value="stage.value"
        :fraction="stage.fraction"
      ></dashboard-bar-row>

      <v-divider class="my-4"></v-divider>

      <v-row dense>
        <v-col cols="6">
          <div class="text-h6 text--primary font-weight-semibold">
            {{ total }}
          </div>
          <div class="text-caption text--secondary">
            медиана от заказа до двери
          </div>
        </v-col>
        <v-col cols="6">
          <div class="text-h6 text--primary font-weight-semibold">
            {{ overHour }}
          </div>
          <div class="text-caption text--secondary">
            заказов везли дольше часа
          </div>
        </v-col>
      </v-row>
    </template>

    <div
      v-else
      class="d-flex align-start text--secondary"
    >
      <v-icon
        size="20"
        class="me-2"
      >
        {{ icons.mdiTimerSand }}
      </v-icon>
      <span>Данные копятся с момента подключения вебхуков — пока считать не из чего.</span>
    </div>
  </dashboard-block>
</template>

<script>
import _ from 'lodash'
import { mdiTimerSand } from '@mdi/js'
import DashboardBlock from '@/views/dashboard/dashboard-block'
import DashboardBarRow from '@/views/dashboard/dashboard-bar-row'
import { plural } from '@/helpers'
import {
  toCountString, toMinutesString, toPercentString, toPeriodString,
} from '@/helpers/dashboard'

const STAGES = [
  { field: 'toKitchenMinutes', label: 'До кухни' },
  { field: 'cookingMinutes', label: 'Готовка и сборка' },
  { field: 'onTheWayMinutes', label: 'В пути' },
]

export default {
  name: 'DashboardSpeed',
  components: { DashboardBlock, DashboardBarRow },
  props: {
    block: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    icons: { mdiTimerSand },
  }),
  computed: {
    caption() {
      if (!this.block || !this.block.hasFigures) return ''

      const { orders, from, to } = this.block
      const period = toPeriodString(from, to)
      const basis = orders === null
        ? 'Медианы'
        : `Медианы по ${toCountString(orders)} ${plural(orders, ['доставленному заказу', 'доставленным заказам', 'доставленным заказам'])}`

      return period ? `${basis} за ${period}` : basis
    },

    stages() {
      const longest = _.max(STAGES.map(stage => this.block[stage.field])) || 0

      return STAGES.map(({ field, label }) => ({
        label,
        value: toMinutesString(this.block[field]),
        fraction: this.block[field] === null || !longest ? null : this.block[field] / longest,
      }))
    },
    total() {
      return toMinutesString(this.block.totalMinutes)
    },
    overHour() {
      return toPercentString(this.block.overHourShare)
    },
  },
}
</script>
